import React, { lazy } from 'react'
import RequireAuthentication from '@/router/guards/RequireAuthentication'

const ScheduledWithoutPreference = lazy(
  () =>
    import('@/modules/Attendance/submodules/ScheduledWithoutPreference/index'),
)

const routes = [
  <RequireAuthentication
    path="/atendimento-agendado/:council/agendamento-sem-preferencia"
    key="atendimento-agendado/agendamento-sem-preferencia"
    exact
    component={ScheduledWithoutPreference}
  />,
]

export default routes
